module.exports = __webpack_public_path__ + "img/2-11.15a3d844.svg";